import { useState, useRef, useEffect } from "react";
import {
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaClock,
  FaUserCircle,
} from "react-icons/fa";
import { RiMailOpenFill } from "react-icons/ri";
import emailjs from "@emailjs/browser";
import "./Contact.css"; // or .scss depending on your setup

export const Contact = () => {
  useEffect(() => {
    document.title = "Contact | Mango Holidays";
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [errorField, setErrorField] = useState(null);
  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  const nameRef = useRef();
  const emailRef = useRef();
  const phoneRef = useRef();
  const messageRef = useRef();
  const formRef = useRef();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name.trim()) {
      setErrorField("name");
      nameRef.current.focus();
      return;
    } else if (
      !formData.email.trim() ||
      !/^\S+@\S+\.\S+$/.test(formData.email)
    ) {
      setErrorField("email");
      emailRef.current.focus();
      return;
    } else if (!formData.phone.trim() || !/^\d{10}$/.test(formData.phone)) {
      setErrorField("phone");
      phoneRef.current.focus();
      return;
    } else if (!formData.message.trim()) {
      setErrorField("message");
      messageRef.current.focus();
      return;
    } else {
      setErrorField(null);
    }

    setLoading(true);
    setStatusMessage("");

    // EmailJS parameters
    emailjs
      .send(
        "service_8r4n6wa",
        "template_w82vabr",
        {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone,
          message: formData.message,
        },
        "e2zd94HBpOuWFzJ4-",
      )
      .then(
        () => {
          setLoading(false);
          setStatusMessage("Your message has been sent successfully!");
          setFormData({ name: "", email: "", phone: "", message: "" });
        },
        (error) => {
          setLoading(false);
          setStatusMessage("Failed to send message. Please try again later.");
          console.error("EmailJS Error:", error);
        },
      );
  };

  const addresses = [
    {
      city: "Pune",
      address: (
        <>
          Mango Holidays <br />
          302, Swojas Capital, near Film Institute, Law Collage Road, Pune ,
          Maharashtra 411004.
        </>
      ),
      contactNo: "Toll Free - 18002685980",
      mobileNo: "+91 8380039505  +91 20 25444415 / 16",

      mailId: "info@mangoholidays.in",
      timming: "10:00 AM to 07:00 PM",
      mapSrc:
        "https://www.google.com/maps?q=Mango+Holidays+India+Pvt.+Ltd,+Pune&output=embed",
    },
    {
      city: "Mumbai",
      address: (
        <>
          Mango Holidays <br />
          "5, Adi House, Gokhale Road - North, near Portuguese Church, Dadar
          Mumbai : 400 028 India",
        </>
      ),
      contactNo: "Toll Free - 18002685980",
      mobileNo: "+91 9225088169 / +91 9225088168 / +91 8380039503",
      mailId: "info@mangoholidays.in",
      timming: "10:00 AM to 07:00 PM",
      mapSrc:
        "https://www.google.com/maps?q=Mango+Holidays+India+Pvt.+Ltd,+Mumbai&output=embed",
    },
  ];

  // Array for Preferred Sales Agents (Scalable for the future)
  const salesAgents = [
    {
      name: "Niyati",
      role: "Preferred Sales Agent",
      phone: "+91 9225088164",
      email: "niyati@mangoholidays.in",
    },
  ];

  return (
    <>
      {/* -- Banner Section -- */}
      <section className="banner-section-contact">
        <div className="img-container-contact">
          <img src="/img/contact-us.webp" alt="Banner Unavailable" />
        </div>
        <div className="banner-overlay-contact">
          <h1 className="banner-title-contact">Contact Us</h1>
        </div>
      </section>

      {/* -- Contact Section --  */}
      <section className="contact-container">
        {/* -- Left Section -- */}
        <div className="contact-left">
          <h2>Connect with us</h2>
          <h3>
            <a href="tel:18002685980">
              <FaPhoneAlt className="icons" /> Toll Free - 1800 268 5980
            </a>
          </h3>
          <h3>
            <a href="mailto:info@mangoholidays.in">
              <RiMailOpenFill className="icons" /> info@mangoholidays.in
            </a>
          </h3>

          <hr />

          <h2>Send us a message</h2>

          <form
            ref={formRef}
            onSubmit={handleSubmit}
            className="form-container"
          >
            <div className="input-group">
              <input
                ref={nameRef}
                id="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                placeholder=" "
                className={errorField === "name" ? "inputError" : ""}
              />
              <label htmlFor="name">Name</label>
            </div>

            <div className="input-group">
              <input
                ref={emailRef}
                id="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder=" "
                className={errorField === "email" ? "inputError" : ""}
              />
              <label htmlFor="email">Email</label>
            </div>

            <div className="input-group">
              <input
                ref={phoneRef}
                id="phone"
                type="text"
                value={formData.phone}
                onChange={handleChange}
                placeholder=" "
                maxLength={10}
                className={errorField === "phone" ? "inputError" : ""}
              />
              <label htmlFor="phone">Phone No.</label>
            </div>

            <div className="input-group">
              <textarea
                ref={messageRef}
                id="message"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                placeholder=" "
                className={errorField === "message" ? "inputError" : ""}
              />
              <label htmlFor="message">Message</label>
            </div>

            <button type="submit" className="btn-c" disabled={loading}>
              <p>{loading ? "Sending..." : "Send Message"}</p>
            </button>

            {statusMessage && <p className="status-message">{statusMessage}</p>}
          </form>
        </div>

        {/* -- Right Section -- */}
        <div className="contact-right">
          {addresses.map((address, index) => (
            <div className="office-details" key={index}>
              <div className="text-details">
                <h2>{address.city}</h2>

                {/* Conditionally rendering fields so empty ones don't show */}
                {address.address && (
                  <h3>
                    <FaMapMarkerAlt className="icons" /> {address.address}
                  </h3>
                )}

                {address.contactNo && (
                  <h3>
                    <FaPhoneAlt className="icons" /> {address.contactNo}
                  </h3>
                )}

                {address.mobileNo && (
                  <h3>
                    <FaPhoneAlt className="icons" /> {address.mobileNo}
                  </h3>
                )}

                {address.mailId && (
                  <h3>
                    <RiMailOpenFill className="icons" /> {address.mailId}
                  </h3>
                )}

                {address.timming && (
                  <h3>
                    <FaClock className="icons" /> {address.timming}
                  </h3>
                )}
              </div>
              <div className="map-box">
                <iframe
                  title={`${address.city} Office`}
                  src={address.mapSrc}
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* -- Sales Agent Section -- */}
      <section className="sales-agent-section">
        <div className="agent-container">
          <h2 className="section-title">Preferred Sales Agents</h2>
          <div className="agents-grid">
            {salesAgents.map((agent, index) => (
              <div className="agent-card" key={index}>
                <div className="agent-avatar">
                  <FaUserCircle />
                </div>
                <div className="agent-info">
                  <h4>{agent.name}</h4>
                  <p className="agent-role">{agent.role}</p>

                  <div className="agent-contact-links">
                    {agent.phone && (
                      <a
                        href={`tel:${agent.phone.replace(/\s+/g, "")}`}
                        className="agent-link"
                      >
                        <FaPhoneAlt className="link-icon" /> {agent.phone}
                      </a>
                    )}

                    {agent.email && (
                      <a href={`mailto:${agent.email}`} className="agent-link">
                        <RiMailOpenFill className="link-icon" /> {agent.email}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};
